module.exports = __webpack_public_path__ + "img/devotion.f0d8baff.png";